import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Store, Plus } from "lucide-react";
import api from "@/lib/api";
import { ListingCard } from "@/components/cards";
import { Loader, SectionHeader, EmptyState, Chip, PrimaryButton, PASSION_LABEL } from "@/components/ui-bits";

const PASSIONS = ["photography", "fitness-wellness", "art-creative", "music", "cooking", "writing"];
const TYPES = [{ id: "creation", l: "Creations" }, { id: "product", l: "Products" }, { id: "service", l: "Services" }];

export default function Marketplace() {
  const [params, setParams] = useSearchParams();
  const passion = params.get("passion") || "";
  const [type, setType] = useState("");
  const [items, setItems] = useState(null);

  useEffect(() => {
    setItems(null);
    const q = new URLSearchParams();
    if (passion) q.set("passion", passion);
    if (type) q.set("listing_type", type);
    api.get(`/marketplace?${q}`).then((r) => setItems(r.data));
  }, [passion, type]);

  const setPassion = (p) => { const np = new URLSearchParams(params); p ? np.set("passion", p) : np.delete("passion"); setParams(np); };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
      <SectionHeader eyebrow="Marketplace" title="Turn passion into opportunity"
        subtitle="Creations, hobby products and services from the community — and yours to sell too."
        action={<PrimaryButton as={Link} to="/create/listing" data-testid="create-listing-cta"><Plus className="h-4 w-4" />Sell something</PrimaryButton>} />

      <div className="flex flex-wrap items-center gap-2 mb-4 overflow-x-auto pb-1">
        <Chip active={!passion} onClick={() => setPassion("")} data-testid="market-filter-all">All passions</Chip>
        {PASSIONS.map((p) => <Chip key={p} active={passion === p} onClick={() => setPassion(p)} data-testid={`market-filter-${p}`}>{PASSION_LABEL[p]}</Chip>)}
      </div>
      <div className="flex flex-wrap items-center gap-2 mb-8">
        <Chip active={type === ""} onClick={() => setType("")}>Everything</Chip>
        {TYPES.map((t) => <Chip key={t.id} active={type === t.id} onClick={() => setType(t.id)} data-testid={`market-type-${t.id}`}>{t.l}</Chip>)}
      </div>

      {!items ? <Loader /> : items.length ? (
        <div className="grid gap-5 grid-cols-2 lg:grid-cols-4" data-testid="marketplace-grid">{items.map((l) => <ListingCard key={l.id} l={l} />)}</div>
      ) : (
        <EmptyState icon={Store} title="Nothing here yet" hint="List a creation, product or service and be the first."
          action={<PrimaryButton as={Link} to="/create/listing">Create a listing</PrimaryButton>} />
      )}
    </div>
  );
}
